
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { constant} from '../../../constants/app.constants';
import { AddToRefillQueueModel,PatientLoginStatusModel, PatientProfilePictureModel, PharmacyInfoModel, ProfileInfoModel, RxHistoryModel, SubscriptionType, UserDetialEmail, UserOTP } from '../models/UserOTP.model';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, of, switchMap } from 'rxjs';
import { InsuCards, PatientNo, UserModel } from '../models/user.model';
import { environment } from '../../../../environments/environment';
import { addSignatureParams, SaleTransactionParams, TransactionDetail } from '../models/transactions.models';
import { messages } from '../../../constants/app.messages';

@Injectable({
  providedIn: 'root'
})
export class PatientEngagementService  {
  constructor(private _http:HttpClient, private _auth:AuthService) { }


  getDrugImagesBasedonNDC(payload: any) {
    return this._http.post(environment.API_BASE_URL  + constant.GET_PENDINGPAYMENTS_GETIMAGEURLS , payload);
  }

  getTransaction (payload: any) {
    return this._http.post(environment.API_BASE_URL  + constant.GET_PENDINGPAYMENTS_TRANSCATION , payload);
  }

  postSendOTP(payload: any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.USER_SEND_OTP, payload);
  }

  postOTP(otpModel:UserOTP){
    return this._http.post<any>(environment.API_BASE_URL  + constant.USER_OTP, otpModel);
  }

  postPatientPharmacyInfo(userModel: { npiData?: string; phoneNumber?: any; patientNo?: string; pharmacyName?: any; user_metadata?: any; }) {
    return this._http.post<any>(environment.API_BASE_URL  + constant.USER_PATIENT_PHARMACY_INFO, userModel);
  }

  postResendOTP(otpModel:UserOTP){
    return this._http.post<any>(environment.API_BASE_URL  + constant.USER_RESEND_OTP, otpModel);
  }

  setUpTrans(payload:SaleTransactionParams){
    return this._http.post<any>(environment.API_BASE_URL  + constant.Get_SETUP_TRANS, payload);
  }

   addSignatureOnly(payload:addSignatureParams){
    return this._http.post<any>(environment.API_BASE_URL  + constant.Get_Transaction_Signature, payload);
  }

  postPharmacyInfo(payload:PharmacyInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_PHARMACY_INFO, payload);
  }

  transactionDetail(payload:any){
    return this._http.get<any>(environment.API_PRIMERX_PAY_BASE_URL  + constant.POST_TRANSDETAILS_INFO + "?primerxPayTransId="+ payload?.primerxPayTransId  + "&applicationTransId=" + payload?.ApplicationTransId + "&transSetupID=" + payload?.TransSetupID + "&applicationId=7&paymentProviderId=1");
  }

  postUserDetails(userModel:PatientNo){
      return this._http.post<any>(environment.API_BASE_URL  + constant.POST_USER_DETAILS, userModel);
  }

  /* /Dashboard/DashboardCounts */

  dashboardCounts(payload:PharmacyInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_DASHBOARD_COUNTS, payload);
  }
 updatePatientLoginStatus(payload:PatientLoginStatusModel): Observable<any> {
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_UPDATE_LOGIN_STATUS, payload);
  }
  dashboardPatientInfo(payload:PharmacyInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_DASHBOARD_PATIENT_INFO, payload);
  }

  savePatientProfileInfo(payload:ProfileInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_PROFILE_UPDATE, payload);
  }

  deletePatientProfileInfo(payload:ProfileInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.DELETE_PROFILE_PICTURE, payload);
  }
  saveProfilePictureId(payload:PatientProfilePictureModel): Observable<any> {
  console.log("patient-engagement.service => saveProfilePictureId environment.prescriptionBaseUrl", environment.prescriptionBaseUrl);
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_PROFILE_PICTUREID, payload);
  }

  myMedsHistory(payload:RxHistoryModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_MYMEDS_HISTORY, payload);
  }

  readyForPickup(payload:PharmacyInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_READY_FOR_PICKUP, payload);
  }

  newErxs(payload:PharmacyInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_NEW_ERXS, payload);
  }

  refillsDue(payload:PharmacyInfoModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_GET_REFILLS_DUE, payload);
  }

  addToRefillQueue(payload:AddToRefillQueueModel): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_ADD_REFILLS_QUE, payload);
  }

  updateSubscription(payload:SubscriptionType){
        return this._http.post<any>(environment.API_BASE_URL  + constant.UPDATE_SUBSCRIPTION, payload);
  }

  postUserDetailEmail(payload:UserDetialEmail): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_USER_DETAIL_EMAIL, payload);
  }


  chatInvoke(patientId:any){
    const headers = new HttpHeaders().set('isLoadNotReq', 'true');
    return this._http.get<any>(environment.Negotiate_apiBaseUrl  + `/${constant.NEGOTIAGE}?userid=${patientId}`, {headers});
  }

  postConversation(payload:any): Observable<any> {
    const reqOptns = {
        headers: new HttpHeaders().set("isSPCBaseUrl", "true")
    };
    return this._http.post(constant.POST_CONVERSATION, payload, reqOptns);
  }

  postMessageMarkAsRead(data: any) {
      const reqOptns = {
          headers: new HttpHeaders().set("isSPCNoProxyBaseUrl", "true")
      };
      return this._http.post(constant.POST_MESSAGE_MARKASREAD , data, reqOptns);
  }

  postMessageUnreadCount(data: any) {
      const reqOptns = {
          headers: new HttpHeaders()
              .set("isSPCNoProxyBaseUrl", "true")
              .set("isLoadNotReq", "true")
      };
      return this._http.post(constant.POST_MESSAGE_UNREADCOUNT , data, reqOptns);
  }

  saveSignature(payload: any){
    const reqOptns = {
      headers: new HttpHeaders().set("isSignatureBaseUrl", "true")
  };
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_SIGNATURE, payload);
  }
  deleteSignature(payload: any){
    const reqOptns = {
      headers: new HttpHeaders().set("isSignatureBaseUrl", "true")
  };
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_DELETE_SIGNATURE, payload);
  }

  //Insurance Endpoints
  addNewInsuranceforPatient(payload : any){
      return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_ADD_INSURANCE, payload);
  }
  addExistanceInsuranceforPatient(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_ADD_EXIST_INSURANCE, payload);
}
  getInsuranceFileData(npi: any): Observable<any> {
    const url = environment.prescriptionBaseUrl + constant.POST_GET_INSURANCEFILE.replace("{npi}", "" + npi);
    return this._http.get<any>(url);
  }
  checkIsInsuranceExistOrNot(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_ISINSURANCE_EXIST, payload);
  }
  checkIsInsuranceActiveOrNot(insurerId: any, npi: any): Observable<any> {
    const url = environment.prescriptionBaseUrl + constant.GET_CHECK_INSURANCE_ACTIVE.replace("{insurerId}", "" + insurerId).replace("{npi}", "" + npi);
    return this._http.get<any>(url);
  }
  getPharmacyLogo(payload : any){
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_PHARMACY_INFO, payload);
  }
  checkImageExists(imageUrl: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (!imageUrl) {
        resolve(false); // If no URL, return false immediately
        return;
      }
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => resolve(true); // Image exists
      img.onerror = () => resolve(false); // Image does not exist
    });
  }

  InsuranceOCRInfo(payload : any): Observable<any>{
    return this._http.post<any>(environment.API_BASE_URL  + constant.GET_OCR_INSURANCE_INFO, payload);
  }
  SaveInsuranceOCRInfo(payload : any): Observable<any>{
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_OCR_TO_BLOB_INSURANCE, payload);
  }


  //External Meds Endpoints

  getPrimerxUserId(): Observable<any>{
     const url = environment.prescriptionBaseUrl + constant.GET_PRIMERX_USER_ID;
    return this._http.get<any>(url);
  }
  getDrugInfo(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.GET_DRUG_INFO, payload);
  }
  getDrugId(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.GET_DRUG_ID, payload);
  }
  addPatExternalMeds(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.ADD_EXTERNAL_MEDS, payload);
  }
  updatePatExternalMeds(payload : any){
     return this._http.put<any>(environment.prescriptionBaseUrl  + constant.UPDATE_EXTERNAL_MEDS, payload);
  }
  deletePatExternalMeds(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.DELETE_EXTERNAL_MEDS, payload);
  }
  getExternalPharmacyInfo(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.GET_PHARMACY_INFO, payload);
  }
  getOrCreateTransferPharmacy(payload : any){
    return this._http.post<any>(environment.API_BASE_URL  + constant.GET_OR_CREATE_TRANSFER_PHARMACY, payload);
  }
  getPatExteranlMeds(patientId : any){
    const url = environment.prescriptionBaseUrl + constant.GET_EXTERNAL_MEDS.replace("{patientId}", "" + patientId);
    return this._http.get<any>(url);
  }
  getTransferPharmacyElink(payload : any){
    return this._http.post<any>(environment.prescriptionBaseUrl  + constant.GET_TRANSFER_ELINK, payload);
  }
  updatePatientDetails(payload: any){
        return this._http.post<any>(environment.prescriptionBaseUrl  + constant.POST_UpdatePatientDetails, payload);

  }

    getSavedCardDetails(payload:any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.GET_SAVED_CARDS_DETAILS, payload);
  }

   cardPayment(payload:any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_PAYMENT, payload);
  }

     saveSignatureandTransaction(payload:any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_SaveTransactionAndSignature, payload);
  }

       updatePaymentCardDetails(payload:any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_UpdateCardDetails, payload);
  }

        deletePaymentCardDetails(payload:any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL  + constant.POST_DeleteCardDetails, payload);
  }


  // Resolve bucket transID to permanent transID
  getPermanentTransId(payload: any): Observable<any> {
    return this._http.post<any>(environment.API_BASE_URL + constant.POST_GetPermanentTransId, payload);
  }

  // Build the same payload ReviewOrder used
  buildSetupSalePayload() {
  const selectedTransDetails = JSON.parse(localStorage.getItem('selectedTransDetails') as string);
  const elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
  const eLinkData = JSON.parse(localStorage.getItem('eLinkData') as string);

  if (!selectedTransDetails?.salesDetailsList?.length || !elinkParams?.npi || !eLinkData?.EntityId) {
    throw new Error('Missing transaction context');
  }

  const TransactionItems = (selectedTransDetails.salesDetailsList || [])
    .filter((x: any) => x?.rxDetails)
    .map((it: any) => ({
      RxNo: it.rxDetails.rxno,
      RefillNo: it.rxDetails.nrefill,
      PartialFillNo: it.rxDetails.partialFillNo,
      DrugName: it.rxDetails.detdrgname,
      Amount: it.rxDetails.copay,
      Quantity: it.rxDetails.quant,
    }));

  return {
    NpiNo: elinkParams.npi,
    PatientNo: String(eLinkData.EntityId),
    Amount: selectedTransDetails.amount,
    TransId: selectedTransDetails.transID,
    TransactionItems,
    allowTokenSaving: selectedTransDetails.allowTokenSaving,
    CustomCss: messages.customCssChanges,
    TransactionSetupMethod: "2"
  };
}

  uploadImage(payload: any){
    return this._http.post<any>(environment.Documentbase_URL  + constant.POST_UPLOAD_IMAGE, payload);
  }


    downloadImage(payload: any){
    return this._http.post<any>(environment.Documentbase_URL  + constant.POST_DOWNLOAD_IMAGE, payload);
  }

     deleteImage(payload: any){
    return this._http.post<any>(environment.Documentbase_URL  + constant.POST_DELETE_IMAGE, payload);
  }


  async getProfilePictureUrl(data: any){
    const payload = {
        Pharmacy: {
          IdentifierType: 0,
          Identifier: data.npi,
          Name: data.pharmacyName || "TEST Community Pharmacy"
        },
        Application: { Id: 1, Name: "Primerx" },
        DocumentIds: [data.profilePictureId],
        RelatedEntity: {
          EntityType: 0,
          Identifier: String(data.patientid),
          Name: data.fullname || "Patient"
        },
        DocumentReference: 2,
        SenderType: 0
      };
      const resp: any = await this.downloadImage(payload).toPromise();
      let foundImageUrl = null;
      if (Array.isArray(resp?.documents)) {
        for (const d of resp.documents) {
          if (
            d?.document?.id &&
            d?.document?.url &&
            d.document.id.toString() === data.profilePictureId.toString()
          ) {
            foundImageUrl = d.document.url;
            console.log(`loadProfilePicture: Found image URL for matching documentId ${d.document.id}:`, foundImageUrl);
            break; // Only take the first match
          }
        }
      }
      return foundImageUrl;
  }

}
